$(document).on('click', '#CartDrawer-Overlay', function() {
  $('.drawer__close').trigger('click')
})
$(document).ready(function () {
  let eventEnabled = true;
  $(".product-form__submit").on("click", function () {
    if (eventEnabled) {
      eventEnabled = false;
    }
  });
  const targetElement = document.querySelector("cart-drawer");
  if (targetElement) {
    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if ($(targetElement).hasClass("anime")) {
            setTimeout(function(){
              // cartUpadte();
              //console.log('active log')
            }, 1500);
            eventEnabled = true;
          }
        }
      }
    });
    observer.observe(targetElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
  } else {
    console.warn("Target element .cart-drawer not found in DOM.");
  }

  $(document).on('click', '.cart_reco_product_card button', function(e) {
    e.preventDefault();
    $(this).parents(".cart_reco_product_card").siblings(".loading-overlay").removeClass("hidden");
    var variantId = $(this).data("id");
    var quantity = 1;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: quantity
      },
      dataType: 'json',
      success: function (item) {        
        $('#CartDrawer .cart_count').load(location.href + " #CartDrawer .cart_count");
        $('#CartDrawer #CartDrawer-CartItems').load(location.href + " #CartDrawer #CartDrawer-CartItems");
        $('#CartDrawer .drawer_upsell').load(location.href + " #CartDrawer .cart-drawer__recommendations");
        $('#CartDrawer .cart-drawer__footer').load(location.href + " #CartDrawer .cart-drawer__footer");
        $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
        function reload_swiper() {        
          var swiper = new Swiper(".cart-drawer__recommendations .swiper", {
            slidesPerView: 'auto',
            spaceBetween: 12,
            navigation: {
               nextEl: ".cart-drawer__recommendations .swiper-button-next",
               prevEl: ".cart-drawer__recommendations .swiper-button-prev",
            }
         });
        }
        setTimeout(function(){
          reload_swiper();
        }, 2000);
        setTimeout(function(){
          reload_swiper();
        }, 2500);
        setTimeout(function(){
          reload_swiper();
        }, 3000);
      },
      error: function (err) {        
        console.error(err);
      }
    });
  });

  setInterval(function () {
    if($("cart-drawer .drawer_upsell").find(".swiper-slide").length == 0){
      $("cart-drawer .drawer_upsell").hide();
      $("cart-drawer .drawer__top").addClass("hide_recommendation");
    }else{
      $("cart-drawer .drawer__top").removeClass("hide_recommendation");
    }
  }, 100);
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('active');
    });

    setTimeout(() => {
      this.classList.add('anime');
    },200);
    
    setTimeout(() => {
      this.classList.add('anime-inner-opacity');
    },800);


    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

  }

  close() {
    setTimeout(() => {
      this.classList.remove('anime');
    },200)
    setTimeout(() => {
      this.classList.remove('active');
    },600);
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState,stop_open) {
    var stop_open_cart = stop_open;
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    if(stop_open_cart != false){
      setTimeout(() => {
        this.open();
      });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


